import { useEffect } from "react";
import { useTranslation } from "react-i18next";

function setMeta(selector: string, attr: "name" | "property", key: string, value: string) {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

/**
 * Server HTML is always rendered in Catalan; this syncs the browser tab title
 * and description meta tags with the visitor's active language after hydration.
 */
export function usePageMeta(title: string | undefined, description?: string) {
  const { i18n } = useTranslation();
  useEffect(() => {
    if (typeof document === "undefined" || !title) return;
    document.title = title;
    document.documentElement.lang = i18n.language;
    setMeta('meta[property="og:title"]', "property", "og:title", title);
    if (description) {
      setMeta('meta[name="description"]', "name", "description", description);
      setMeta('meta[property="og:description"]', "property", "og:description", description);
    }
  }, [title, description, i18n.language]);
}
